module.exports = __webpack_public_path__ + "img/service-nongmaojianguan4.ce6b2d26.svg";